export const GlobalLessonPreviewContentSides = {
    left: 'leftSide',
    right: 'rightSide',
    top: 'topPlacement',
    bottom: 'bottomPlacement',
}
